export default {
  NumberInput: {
    parts: ['root', 'field', 'stepper', 'stepperGroup'],
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
